module.exports = __webpack_public_path__ + "img/wavemoney.70be8c58.png";